import { isValid, parseISO } from 'date-fns'

import type { FormField } from '@/types/api/form'
import type { RecordListItem } from '@/types/api/record'
import type { FormFieldType } from '@/types/enums'
import { formatFieldValue } from '@/utils/field-formatters'

export function rawValue(record: RecordListItem, key: string | undefined): string {
  if (!key) return ''
  return record.values.find((v) => v.formFieldKey === key)?.value ?? ''
}

export function displayValue(record: RecordListItem, field: FormField): string {
  const raw = rawValue(record, field.key)
  if (!raw) return ''
  try {
    return formatFieldValue(raw, field.type as FormFieldType)
  } catch {
    return raw
  }
}

export function parseDay(value: string): Date | null {
  if (!value) return null
  const date = parseISO(value)
  return isValid(date) ? date : null
}

export function recordHref(record: RecordListItem): string {
  return `/record-groups/${record.recordGroupId}/records/${record.recordId}`
}

export function recordTitle(record: RecordListItem): string {
  return record.title?.trim() || 'Untitled record'
}

/** Field types a view can use as a date axis. */
export const DATE_FIELD_TYPES: ReadonlySet<string> = new Set(['DATE', 'DATETIME'])
/** Field types a board can group by. */
export const CHOICE_FIELD_TYPES: ReadonlySet<string> = new Set(['SELECT', 'RADIO'])
